import { render, staticRenderFns } from "./InstructionalVideos.vue?vue&type=template&id=df304b28&scoped=true&"
import script from "./InstructionalVideos.vue?vue&type=script&lang=js&"
export * from "./InstructionalVideos.vue?vue&type=script&lang=js&"
import style0 from "./InstructionalVideos.vue?vue&type=style&index=0&id=df304b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df304b28",
  null
  
)

export default component.exports